/**
 * @generated SignedSource<<3e5fbf70d53cc4c2588e4683b8b70a4a>>
 * @relayHash 2767422e76a7022823847b600b13d70c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 361d7195e6b8202fcba393afd1c8dc1d2b4cccfd794d2ae04b746fc1701c8715

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SettingsViewQuery_TeamsSettingsQuery$variables = {
  isSiteScopedNotificationsEnabled: boolean;
  orgId: string;
  permissionsEnabled: boolean;
  scopeId: string;
  shouldLoadCustomFields: boolean;
  shouldLoadNotifications: boolean;
  shouldLoadTeamTypeEdit: boolean;
  shouldLoadTeamTypes: boolean;
  siteId: string;
  teamTypeId: string;
};
export type SettingsViewQuery_TeamsSettingsQuery$data = {
  readonly team?: {
    readonly " $fragmentSpreads": FragmentRefs<"NotificationsTable_teamNotifications">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CustomFieldsScreen_data" | "SettingsHeader_TeamTypeEditPageTitle_data" | "TeamTypesEditScreenNext_data" | "TeamTypesScreen_data">;
};
export type SettingsViewQuery_TeamsSettingsQuery = {
  response: SettingsViewQuery_TeamsSettingsQuery$data;
  variables: SettingsViewQuery_TeamsSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSiteScopedNotificationsEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "permissionsEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scopeId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldLoadCustomFields"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldLoadNotifications"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldLoadTeamTypeEdit"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldLoadTeamTypes"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamTypeId"
},
v10 = {
  "kind": "Variable",
  "name": "organizationId",
  "variableName": "orgId"
},
v11 = {
  "kind": "Variable",
  "name": "siteId",
  "variableName": "siteId"
},
v12 = {
  "kind": "Variable",
  "name": "scopeId",
  "variableName": "scopeId"
},
v13 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamTypeId"
  },
  (v12/*: any*/)
],
v14 = {
  "kind": "ScalarField",
  "name": "id"
},
v15 = {
  "kind": "ScalarField",
  "name": "name"
},
v16 = [
  (v14/*: any*/),
  (v15/*: any*/)
],
v17 = [
  (v12/*: any*/)
],
v18 = {
  "kind": "ScalarField",
  "name": "verified"
},
v19 = {
  "kind": "ScalarField",
  "name": "description"
},
v20 = {
  "kind": "ScalarField",
  "name": "default"
},
v21 = {
  "kind": "ScalarField",
  "name": "state"
},
v22 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v23 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v24 = {
  "kind": "ScalarField",
  "name": "isVerified"
},
v25 = {
  "kind": "ScalarField",
  "name": "largeAvatarImageUrl"
},
v26 = {
  "concreteType": "TeamType",
  "kind": "LinkedField",
  "name": "type",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v14/*: any*/)
  ]
},
v27 = {
  "kind": "ScalarField",
  "name": "type"
},
v28 = {
  "fields": [
    {
      "items": [
        {
          "kind": "Variable",
          "name": "teamTypeIds.0",
          "variableName": "teamTypeId"
        }
      ],
      "kind": "ListValue",
      "name": "teamTypeIds"
    }
  ],
  "kind": "ObjectValue",
  "name": "teamTypes"
},
v29 = {
  "kind": "Literal",
  "name": "showEmptyTeams",
  "value": true
},
v30 = [
  {
    "fields": [
      {
        "kind": "Literal",
        "name": "query",
        "value": ""
      },
      (v28/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  },
  (v10/*: any*/),
  (v29/*: any*/),
  (v11/*: any*/)
],
v31 = [
  {
    "kind": "Variable",
    "name": "ari",
    "variableName": "orgId"
  }
],
v32 = {
  "kind": "ScalarField",
  "name": "notificationType"
},
v33 = {
  "kind": "ScalarField",
  "name": "notificationChannel"
},
v34 = {
  "kind": "ScalarField",
  "name": "enabled"
},
v35 = {
  "kind": "ScalarField",
  "name": "ari"
},
v36 = [
  (v32/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/),
  (v35/*: any*/)
],
v37 = [
  (v32/*: any*/),
  (v33/*: any*/),
  (v35/*: any*/),
  (v34/*: any*/)
],
v38 = [
  {
    "kind": "Variable",
    "name": "ari",
    "variableName": "scopeId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SettingsViewQuery_TeamsSettingsQuery",
    "selections": [
      {
        "condition": "shouldLoadTeamTypes",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "TeamTypesScreen_data"
          }
        ]
      },
      {
        "condition": "shouldLoadTeamTypeEdit",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v10/*: any*/),
              {
                "kind": "Variable",
                "name": "permissionsEnabled",
                "variableName": "permissionsEnabled"
              },
              (v11/*: any*/),
              {
                "kind": "Variable",
                "name": "teamTypeId",
                "variableName": "teamTypeId"
              }
            ],
            "kind": "FragmentSpread",
            "name": "TeamTypesEditScreenNext_data"
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "SettingsHeader_TeamTypeEditPageTitle_data"
      },
      {
        "condition": "shouldLoadCustomFields",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CustomFieldsScreen_data"
          }
        ]
      },
      {
        "condition": "shouldLoadNotifications",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "NotificationsTable_teamNotifications"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v9/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v8/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "SettingsViewQuery_TeamsSettingsQuery",
    "selections": [
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "args": (v13/*: any*/),
            "concreteType": "TeamType",
            "kind": "LinkedField",
            "name": "typeInformation",
            "plural": false,
            "selections": (v16/*: any*/)
          }
        ]
      },
      {
        "condition": "shouldLoadTeamTypes",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "args": (v17/*: any*/),
                "concreteType": "TeamTypeConnection",
                "kind": "LinkedField",
                "name": "typesWithinScope",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TeamTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TeamType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v18/*: any*/),
                          (v15/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldLoadTeamTypeEdit",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "args": (v13/*: any*/),
                "concreteType": "TeamType",
                "kind": "LinkedField",
                "name": "typeInformation",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v18/*: any*/),
                  (v20/*: any*/)
                ]
              },
              {
                "args": (v17/*: any*/),
                "concreteType": "TeamTypeConnection",
                "kind": "LinkedField",
                "name": "typesWithinScope",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TeamTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TeamType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v20/*: any*/),
                          (v14/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "permissionsEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v13/*: any*/),
                    "concreteType": "TeamType",
                    "kind": "LinkedField",
                    "name": "typeInformation",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TeamTypePermissionDelegationConnection",
                        "kind": "LinkedField",
                        "name": "typeLevelPermissions",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TeamTypeLevelPermissionDelegation",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TeamTypeLevelPermissionDetails",
                                "kind": "LinkedField",
                                "name": "permissions",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "permission"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "granted"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "canBeModified"
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "entity",
                                "plural": false,
                                "selections": [
                                  (v22/*: any*/),
                                  (v14/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          (v22/*: any*/),
                                          (v14/*: any*/),
                                          (v15/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "picture"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "email"
                                              }
                                            ],
                                            "type": "AtlassianAccountUser"
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "TeamTypePermissionAssignedUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "IdentityGroup",
                                        "kind": "LinkedField",
                                        "name": "group",
                                        "plural": false,
                                        "selections": (v16/*: any*/)
                                      }
                                    ],
                                    "type": "TeamTypePermissionAssignedGroup"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "TeamV2",
                                        "kind": "LinkedField",
                                        "name": "team",
                                        "plural": false,
                                        "selections": [
                                          (v14/*: any*/),
                                          (v23/*: any*/),
                                          (v24/*: any*/),
                                          (v25/*: any*/),
                                          (v21/*: any*/),
                                          (v26/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "TeamTypePermissionAssignedTeam"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v27/*: any*/)
                                    ],
                                    "type": "TeamTypeLevelDefaultPermissionEntity"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "args": (v30/*: any*/),
                "concreteType": "TeamSearchResultConnectionV2",
                "kind": "LinkedField",
                "name": "teamSearchV2",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TeamSearchResultEdgeV2",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TeamSearchResultV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TeamV2",
                            "kind": "LinkedField",
                            "name": "team",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v23/*: any*/),
                              (v19/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v21/*: any*/),
                              (v26/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "memberCount"
                          },
                          (v22/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v30/*: any*/),
                "filters": [
                  "organizationId",
                  "siteId",
                  "filter",
                  "showEmptyTeams"
                ],
                "handle": "connection",
                "key": "TeamsTable_teamSearchV2",
                "kind": "LinkedHandle",
                "name": "teamSearchV2"
              }
            ]
          },
          {
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "args": (v17/*: any*/),
                "concreteType": "TeamTypeConnection",
                "kind": "LinkedField",
                "name": "typesWithinScope",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TeamTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TeamType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v19/*: any*/),
                          (v18/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "hasTeams",
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "fields": [
                      (v28/*: any*/)
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 5
                  },
                  (v10/*: any*/),
                  (v29/*: any*/),
                  (v11/*: any*/)
                ],
                "concreteType": "TeamSearchResultConnectionV2",
                "kind": "LinkedField",
                "name": "teamSearchV2",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TeamSearchResultEdgeV2",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v22/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldLoadCustomFields",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "args": (v17/*: any*/),
                "concreteType": "TeamCustomFieldInfo",
                "kind": "LinkedField",
                "name": "customFieldsWithinScope",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  (v27/*: any*/),
                  (v15/*: any*/),
                  (v19/*: any*/),
                  {
                    "concreteType": "TeamType",
                    "kind": "LinkedField",
                    "name": "teamType",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v18/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldLoadNotifications",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "condition": "isSiteScopedNotificationsEnabled",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "args": (v31/*: any*/),
                    "concreteType": "TeamNotificationConfiguration",
                    "kind": "LinkedField",
                    "name": "notificationConfigurations",
                    "plural": true,
                    "selections": (v36/*: any*/)
                  },
                  {
                    "args": (v31/*: any*/),
                    "concreteType": "TeamScopeNotificationConfiguration",
                    "kind": "LinkedField",
                    "name": "scopeNotificationConfigurations",
                    "plural": true,
                    "selections": (v37/*: any*/)
                  }
                ]
              },
              {
                "condition": "isSiteScopedNotificationsEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "siteNotificationConfigurations",
                    "args": (v38/*: any*/),
                    "concreteType": "TeamNotificationConfiguration",
                    "kind": "LinkedField",
                    "name": "notificationConfigurations",
                    "plural": true,
                    "selections": (v36/*: any*/)
                  },
                  {
                    "alias": "siteScopeNotificationConfigurations",
                    "args": (v38/*: any*/),
                    "concreteType": "TeamScopeNotificationConfiguration",
                    "kind": "LinkedField",
                    "name": "scopeNotificationConfigurations",
                    "plural": true,
                    "selections": (v37/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "361d7195e6b8202fcba393afd1c8dc1d2b4cccfd794d2ae04b746fc1701c8715",
    "metadata": {},
    "name": "SettingsViewQuery_TeamsSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2473c1fdf08249d49ab8d273e8a4da73";

export default node;
